import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchBookedServices } from "../../../redux/actions/bookedServicesAction";
import capitalizeFirstLetter from "../../comman/capitalizeFirstLetter";

export default function CompletedService() {
  const navigate=useNavigate();
  const [loading,setLoading]=useState(false);
    const dispatch=useDispatch();
    const { bookedservices=[], error } = useSelector(
          (state) => state.bookedServiceState
      );
      
    useEffect(() => {
        const fetchData = async () => {
          try {
            setLoading(true);
            dispatch(fetchBookedServices());
          } finally {
            setLoading(false);
          }
        };   
        fetchData();
    }, [dispatch]);
  
    if(error){
      return(<p className="text-red-600">{error}</p>);
    }
  
    if (loading) {
      return <p className="text-center text-gray-500 py-10">Loading booked services...</p>;
    }
  
    const completedServices = bookedservices.filter(
      (item) => item.status?.toLowerCase() === "completed"
    );
  return (
    <section className="px-4 py-6">
      {completedServices.length == 0 ? (
        <div className="text-gray-600 flex flex-col justify-center space-y-4 w-full">
          <p>No completed service found for your account.</p>
          <Link to="/service">
            <button className="px-4 py-2 bg-[#A63F40] text-white rounded">Explore Services</button>
          </Link>
        </div>
      ): (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:gap-8">
        {completedServices.map((row, idx) => (
          <div
            key={idx}
            className="flex flex-col md:flex-row  md:space-x-3 items-center md:items-start md:justify-between gap-4 rounded-lg shadow p-4 md:px-2 md:py-4 xl:p-4 bg-slate-100"
          >            
             <div className="w-full md:w-3/4 xl:w-2/3 flex flex-col gap-1 text-gray-800 font-medium text-xs md:text-sm xl:text-base">
              <p>Order ID: {row.bookedServiceId}</p>
              <p>Placed Order :{" "}
                {row.createdAt
                  ? new Date(row.createdAt).toLocaleDateString("en-US", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                })
                : "—"}
              </p>
              <p>
                Status:{" "} 
                <span className="text-green-600">
                  {row.status ? capitalizeFirstLetter(row.status): "-"}
                </span>
              </p>
            </div>

             <div className="w-full md:w-1/4 xl:w-1/3 flex md:flex-col justify-between md:justify-center items-center md:items-end gap-2 text-xs md:text-sm">
      
              <button
                className="w-[115px] xl:w-32 border border-[#A63F40] px-2 xl:px-3 py-1 text-[#A63F40] bg-[#f3e5e5] hover:bg-[#e8d2d2] transition rounded shadow"
                onClick={() => navigate(`/viewupcomingservices/${row.bookedServiceId}`,{ state: { activeStep: 2 }})}
              >
                View Details
              </button>
            </div>
          </div>
        ))}
      </div>
      )}
    </section>
  );
}

